module.exports={
  "climate-change": {
    "climate-change-issue-1": {
      "climate-change-issue-1-answer-1": "Increase DWP rates",
      "climate-change-issue-1-answer-2": "Enforce rationing",
      "climate-change-issue-1-answer-3": "Encourage voluntary conservation, but be willing to enforce rationing",
      "climate-change-issue-1-answer-4": "Individual water use is not the right intervention point",
      "climate-change-issue-1-answer-5": "Promote conservation, but also secure our local water supply by modernizing our infrastructure, recycling water, capturing rain and stormwater, and using native or drought-tolerant plants"
    },
    "climate-change-issue-2": {
      "climate-change-issue-2-answer-1": "Convert all city transportation to electric or hydrogen",
      "climate-change-issue-2-answer-2": "Expand public transit",
      "climate-change-issue-2-answer-3": "Help Angelenos live closer to their work to reduce transportation within the city",
      "climate-change-issue-2-answer-4": "Make our streets safer for pedestrians, expand our electric vehicle network, and electrify our bus fleet"
    }
  },
  "homelessness": {
    "homelessness-issue-1": {
      "homelessness-issue-1-answer-1": "Keep it as is",
      "homelessness-issue-1-answer-2": "Keep it, but expand support for those experiencing homelessness",
      "homelessness-issue-1-answer-3": "Change the law, or change how it's implemented",
      "homelessness-issue-1-answer-4": "Repeal it"
    },
    "homelessness-issue-2": {
      "homelessness-issue-2-answer-1": "A history of racial inequity in housing and wealth",
      "homelessness-issue-2-answer-2": "Economic hardship",
      "homelessness-issue-2-answer-3": "It’s not that simple. It's a complex problem that includes issues like housing costs, addiction and mental illness, racial and social inequity, and a crumbling social safety net"
    },
    "homelessness-issue-3": {
      "homelessness-issue-3-answer-1": "Yes, the homelessness crisis makes everyone less safe",
      "homelessness-issue-3-answer-2": "Yes, but most significantly for the people living on the streets",
      "homelessness-issue-3-answer-3": "It's debatable",
      "homelessness-issue-3-answer-4": "No"
    },
    "homelessness-issue-4": {
      "homelessness-issue-4-answer-1": "The city. The public/private partnership has resulted in our tax dollars being transferred to the private sector",
      "homelessness-issue-4-answer-2": "Private developers",
      "homelessness-issue-4-answer-3": "Both. We need an all-hands-on-deck approach with support from public and private partners",
      "homelessness-issue-4-answer-4": "We need to focus on temporary stabilization, not permanent housing"
    },
    "homelessness-issue-5": {
      "homelessness-issue-5-answer-1": "Red tape, funding challenges or bureaucratic hurdles",
      "homelessness-issue-5-answer-2": "NIMBYism (\"Not In My Back Yard\")",
      "homelessness-issue-5-answer-3": "Restrictive zoning, and having no requirement that new developments include affordable units",
      "homelessness-issue-5-answer-4": "The growing number of private equity firms involved in the process has made securing financing for developers more difficult"
    }
  },
  "policing": {
    "policing-issue-1": {
      "policing-issue-1-answer-1": "Increase to full authorized force (around 9,700)",
      "policing-issue-1-answer-2": "Increase to 10,000 or more",
      "policing-issue-1-answer-3": "Downsize",
      "policing-issue-1-answer-4": "Keep the same"
    },
    "policing-issue-2": {
      "policing-issue-2-answer-1": "Increase",
      "policing-issue-2-answer-2": "Decrease",
      "policing-issue-2-answer-3": "Stay the same"
    },
    "policing-issue-3": {
      "policing-issue-3-answer-1": "Yes",
      "policing-issue-3-answer-2": "No"
    },
    "policing-issue-4": {
      "policing-issue-4-answer-1": "Yes",
      "policing-issue-4-answer-2": "No"
    },
    "policing-issue-5": {
      "policing-issue-5-answer-1": "Broadly aligns with my beliefs",
      "policing-issue-5-answer-2": "I disagree with some of his agenda",
      "policing-issue-5-answer-3": "I think he should be recalled from office"
    }
  }
}